var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visiable,
      expression: "visiable"
    }],
    staticClass: "flex items-center justify-center min-h-[230px] mx-[10px]"
  }, [_c('div', {
    staticClass: "flex flex-col w-full md:flex-row flex-1 min-w-0 rounded-md border border-[#E9ECEF]"
  }, [_c('div', {
    staticClass: "flex-1 flex flex-col gap-4 bg-[#F8F9FA] p-3"
  }, [_c('div', {
    staticClass: "text-[16px] font-bold text-[#333333] flex justify-between"
  }, [_c('span', [_vm._v(`${$t("itc7xa4", "邀请链接")} `)]), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.value.inviteCode,
      expression: "value.inviteCode"
    }],
    staticClass: "text-[#495057]",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v($t("fljd2", "复制"))])], 1), _c('p', {
    staticClass: "text-[14px] text-[#666666]"
  }, [_vm._v($t("319sud", "用户可访问链接申请加入组织"))]), _c('div', {
    staticClass: "bg-[#EFF0F1] p-2 rounded-lg shadow-sm break-all whitespace-pre-wrap text-left flex-1",
    domProps: {
      "innerHTML": _vm._s(_vm.copyText.html)
    }
  })]), _c('div', {
    staticClass: "devicer"
  }), _c('div', {
    staticClass: "flex-1 flex flex-col gap-4 bg-[#F8F9FA] p-3"
  }, [_c('div', {
    staticClass: "text-[16px] font-bold text-[#333333] flex justify-between"
  }, [_c('span', [_vm._v($t("ereoqe5", "组织二维码"))]), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.value.inviteCode,
      expression: "value.inviteCode"
    }],
    staticClass: "text-[#495057]",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.downLoad
    }
  }, [_vm._v($t("vknegp5", "下载二维码"))])], 1), _c('div', {
    staticClass: "text-[14px] text-[#666666]"
  }, [_vm._v($t("cz7e01c", "成员可扫码二维码加入部门"))]), _c('div', {
    staticClass: "rounded-lg shadow-sm flex items-center p-2 gap-2 flex-1"
  }, [_c('canvas', {
    ref: "canvasRef",
    staticClass: "w-[100px] h-[100px]"
  })])])]), _c('div', {
    ref: "downloadRef",
    staticClass: "hotel-qrcard fixed top-[-999%] flex-1 min-w-0 float-left"
  }, [_c('h2', {
    staticClass: "hotel-name"
  }, [_vm._v(_vm._s(_vm.user.userInfo.unitName))]), _c('div', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "qrcode-container"
  }, [_c('canvas', {
    ref: "qrcodeCanvas",
    staticClass: "qrcode-img"
  })]), _c('div', {
    staticClass: "hotel-info"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v($t("izkuv05", "单位代码："))]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.user.userInfo.unitCode))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.deptName,
      expression: "deptName"
    }],
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v($t("trpk905", "所属部门："))]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.deptName))])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };